import { useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery, useMutation, useAction } from "convex/react";
//import { useQueries } from "convex-helpers/react";
//import { api } from "../../convex/_generated/api";
import {api} from "./convex/_generated/api"
//import { useCurrentUser } from "../context/UserContext";
import MealCard from "./components/MealCard";
//import Loader from "../components/Loader";
import "./MealPlan.css";


export default function MealPlan() {
  // FIX: `location` was used but never obtained - needed useLocation().
  const location = useLocation();

  const sessionId =
    location.state?.sessionId || localStorage.getItem("session_id");
  //console.log(sessionId)

  // Get user from session
  const user = useQuery(
    api.users.getUserBySession,
    sessionId ? { sessionId } : "skip"
  );

  //console.log(user?._id)
  const userId = user?._id;

  const navigate = useNavigate();

  const suggestions = useQuery(
    api.suggestions.getSuggestions,
    userId ? { userId } : "skip"
  );

  //console.log(suggestions)

  //const swapMeals = useMutation(api.meals.swapMeals);
  const swapMeals = useAction(api.ai.swapMeals);
  const updateSuggestionCost = useAction(api.ai.updateSuggestionCost);
  const [dietFilter, setDietFilter] = useState("");
  const [cuisineFilter, setCuisineFilter] = useState("");
  const [cookTimeFilter, setCookTimeFilter] = useState("");

  const [swapSelection, setSwapSelection] = useState([]);

  const toggleSwapSelect = (mealId) => {
    setSwapSelection((prev) => {
      if (prev.includes(mealId))
        return prev.filter((id) => id !== mealId);

      if (prev.length === 2)
        return [prev[1], mealId];

      return [...prev, mealId];
    });
  }

  async function confirmSwap(suggestion) {
    if (swapSelection.length !== 2) return;

    await swapMeals({
        mealIdA: swapSelection[0],
        mealIdB: swapSelection[1],
        username: suggestion.username,
      });

    setSwapSelection([]);
  }

  //const filteredSuggestions = (suggestions ?? []).filter((suggestion) => {

    //if (
      //dietFilter !== "All" &&
      //suggestion.dietaryRestriction !== dietFilter
    //) {
      //return false;
    //}

    //if (
      //cuisineFilter !== "All" &&
      //suggestion.cuisineType !== cuisineFilter
    //) {
      //return false;
    //}

    //return true;
  //});

  //const filteredSuggestions =
  //(suggestions ?? [])
    //.filter(
      //suggestion =>
        //suggestion.dietaryRestriction === ""
    //);

  //const filteredSuggestions =
  //(suggestions ?? [])
    //.filter(
      //suggestion =>
        //suggestion.dietaryRestriction === "None"
    //);


  const filteredSuggestions= suggestions ?? [];

    
  //console.log(suggestions);
  //console.log("filtered");
  //console.log(filteredSuggestions);

  // This still replaces calling useQuery(...) directly inside
  // suggestions.filter().map(...), which broke the Rules of Hooks -
  // the number of useQuery calls changed every time a filter changed
  // the list length, and React throws the moment that happens.
  //
  // useQueries (from convex-helpers, built exactly for this) takes one
  // object describing however many queries you need *this render* and
  // subscribes to all of them from a single hook call. Still one query
  // per suggestion, still all in this one component - just built the
  // way Convex actually supports a dynamic-length list of queries.
  //const mealQueries = useMemo(() => {
    //const queries = {};
    //filteredSuggestions.forEach((suggestion) => {
      //queries[suggestion._id] = {
       // query: api.meals.getMealsBySuggestion,
        //args: {
          //suggestionId: suggestion._id,
          //username: suggestion.username,
        //},
      //};
    //});
    //return queries;
  //}, [filteredSuggestions]);

  const pantryQueries = useMemo(() => {
    const queries = {};
    filteredSuggestions.forEach((suggestion) => {
      queries[suggestion._id] = {
        query: api.pantry.getPantryBySuggestion,
        args: {
          suggestionId: suggestion._id,
          username: suggestion.username,
        },
      };
    });
    return queries;
  }, [filteredSuggestions]);

  //const mealsBySuggestion = useQueries(mealQueries);

  //const rawMeals = useQuery(
  //api.meals.getMealsBySuggestions,
  //{
    //suggestionIds: filteredSuggestions.map(
      //suggestion => suggestion._id
    //),
    //username: filteredSuggestions[0]?.username ?? ""
  //}
//);

 const rawMeals = useQuery(
  api.meals.getMealsBySuggestions,
  filteredSuggestions.length > 0
    ? {
        suggestionIds: filteredSuggestions.map(
          suggestion => suggestion._id
        ),
        username: filteredSuggestions[0].username
      }
    : "skip"
);


  const mealsBySuggestion = useMemo(() => {
        

        const grouped = {};

        (rawMeals ?? []).forEach((meal)=>{

           //console.log("MEAL:", meal);
           // console.log("SUGGESTION ID:", meal.suggestionId);

          if(!grouped[meal.suggestionId]){
            grouped[meal.suggestionId] = [];
          }

          grouped[meal.suggestionId].push(meal);

        });
        return grouped;

      },[rawMeals]);

  //const rawPantry = useQuery(
    //    api.pantry.getPantryBySuggestions,   // renamed - plural, avoids colliding
      //                                        // with the existing singular
        //                                      // getPantryBySuggestion
        //{
          //suggestionIds: filteredSuggestions.map(
            //suggestion => suggestion._id
          //),
          //username: filteredSuggestions[0]?.username ?? ""
        //}
      //);

  const rawPantry = useQuery(
  api.pantry.getPantryBySuggestions,
  filteredSuggestions.length > 0
    ? {
        suggestionIds: filteredSuggestions.map(
          suggestion => suggestion._id
        ),
        username: filteredSuggestions[0].username
      }
    : "skip"
);

  const pantryBySuggestion = useMemo(() => {
      const grouped = {};
      (rawPantry ?? []).forEach((item) => {
        if (!grouped[item.suggestionId]) grouped[item.suggestionId] = [];
        grouped[item.suggestionId].push(item);
      });
      return grouped;
    }, [rawPantry]);

  //const pantryBySuggestion = useQueries(pantryQueries);

  // FIX: this was fully commented out, so the JSX below ran against
  // `suggestions === undefined` on every load, before the query
  // resolved. All hooks above are called unconditionally regardless of
  // this check, so it's safe to bail out here without breaking the
  // Rules of Hooks.
  //if (user === undefined || suggestions === undefined) {
    //return <Loader />;
  //}

  return (
    <div className="page-bg">
    <div className="screen">

      <div className="eyebrow">
        Weekly Meal Plans
      </div>

      <h1 className="page-title">
        Your Suggestions
      </h1>

      <div
        style={{
          display: "flex",
          gap: 12,
          flexWrap: "wrap",
          margin: "20px 0",
        }}
      >

      <select
        value={dietFilter}
        onChange={(e) => setDietFilter(e.target.value)}
      >
      <option value="All">All</option>
      <option value="Vegan">Vegan</option>
      <option value="Vegetarian">Vegetarian</option>
      <option value="Keto">Keto</option>
      <option value="Halal">Halal</option>
      <option value="Gluten-Free">Gluten-Free</option>
      </select>

      <select
        value={cuisineFilter}
        onChange={(e) => setCuisineFilter(e.target.value)}
      >
        <option>All</option>
        <option>Italian</option>
        <option>Mexican</option>
        <option>Indian</option>
        <option>Chinese</option>
        <option>American</option>
      </select>

      <select
        value={cookTimeFilter}
        onChange={(e) => setCookTimeFilter(e.target.value)}
      >
        <option value="All">All Times</option>
        <option value="15">Under 15 min</option>
        <option value="30">Under 30 min</option>
        <option value="60">Under 60 min</option>
      </select>

    </div>

      {filteredSuggestions.length === 0 && (
        <div className="empty-state">
          <p>No meal plans generated yet.</p>
        </div>
      )}

      {filteredSuggestions.map((suggestion) => {

        //const meals = mealsBySuggestion[suggestion._id];
        //const pantry = pantryBySuggestion[suggestion._id];
        //const meals = mealsBySuggestion[suggestion._id];
        //console.log("raw");
        //console.log(rawMeals);
        //console.log("filt")
        //console.log(filteredSuggestions);
         //const meals = (rawMeals ?? []).filter(
    //meal => meal.suggestionId === suggestion._id
  //);    
        const meals= mealsBySuggestion[suggestion._id] || [];
        const pantry = pantryBySuggestion[suggestion._id] ?? [];
        //console.log("meals");
        //console.log(meals);

      

        // FIX: this was commented out, but useQueries returns undefined
        // for each entry until its query resolves - meals/pantry are
        // both undefined on first render, and .reduce()/.length below
        // would throw immediately.
        //if (!meals || !pantry) {
          //return <Loader key={suggestion._id} />;
        //}

        //const totalCost = meals.reduce(
         // (sum, meal) => sum + meal.estimatedCost,
          //0
        //);
        const pantryCost = pantry.reduce(
            (sum, item) => sum + item.cost,
            0
        );

        const totalCost = pantryCost;

        return (

          <div
            key={suggestion._id}
            className="ticket"
            style={{ marginBottom: 32, padding: 18 }}
          >

            <h2 className="ticket-title" style={{ fontSize: 19 }}>
              Generated{" "}
              {new Date(
                suggestion._creationTime
              ).toLocaleDateString()}
            </h2>

            <div className="chip-row" style={{ marginTop: 8, marginBottom: 4 }}>
              <span className="pill accent">{suggestion.cuisineType}</span>
              <span className="pill">{suggestion.dietaryRestriction}</span>
            </div>

            <div className="stat-grid" style={{ marginTop: 16 }}>

              <div className="stat-box">
                <div className="stat-value">
                  ${totalCost.toFixed(0)}
                </div>

                <div className="stat-label">
                  Estimated Cost
                </div>
              </div>

              <div className="stat-box">
                <div className="stat-value">
                  {meals.length}
                </div>

                <div className="stat-label">
                  Meals
                </div>
              </div>

            </div>

            {swapSelection.length > 0 && (
              <div
                className="ticket"
                style={{
                  background: "var(--accent-dim)",
                  marginTop: 16,
                }}
              >
                <p style={{ margin: 0, fontSize: 13 }}>
                  {swapSelection.length === 1
                    ? "Select another meal to swap."
                    : "Ready to swap."}
                </p>

                {swapSelection.length === 2 && (
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => confirmSwap(suggestion)}
                    style={{ marginTop: 10 }}
                  >
                    Confirm Swap
                  </button>
                )}
              </div>
            )}

            {[1,2,3,4,5,6,7].map((day) => (

              <div
                key={day}
                style={{ marginTop: 24 }}
              >

                <h3 className="day-heading">Day {day}</h3>

                {meals
                  //.filter((meal) => {

                  //console.log(meals.map(m => ({
                    //    name: m.mealName,
                      //  day: m.dayNumber,
                       // type: typeof m.dayNumber
                      //})));

                    //if (meal.dayNumber !== day)
                      //return false;

                    //if (
                      //cookTimeFilter !== "All" &&
                     // meal.cookTime > Number(cookTimeFilter)
                    //)
                      //return false;

                    //return true;

                  //})
                  .map((meal) => (

                    <MealCard
                      key={meal._id}
                      meal={meal}
                      selected={swapSelection.includes(meal._id)}
                      onClick={() =>
                        // FIX: was `${username}` - undefined anywhere in
                        // this component. This route is keyed by
                        // suggestion/username the same way the queries
                        // above already are, so use suggestion.username.
                        navigate(`/recipe/${user._id}/${meal.mealName}/${suggestion._id}`)
                      }
                      footer={
                        <div
                            style={{
                            display: "flex",
                            gap: 8,
                            marginTop: 8,
                            }}
                        >
                            <button
                            className="btn btn-primary btn-sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/recipe/${user._id}/${meal.mealName}/${suggestion._id}`);
                            }}
                            >
                            View Recipe
                            </button>

                            <button
                            className="btn btn-ghost btn-sm"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleSwapSelect(meal._id);
                            }}
                            >
                            {swapSelection.includes(meal._id)
                                ? "Selected"
                                : "Swap"}
                            </button>
                        </div>
                        }
                    />

                  ))}

              </div>

            ))}

            <h3 className="category-header" style={{ marginTop: 30 }}>
              Pantry
            </h3>

            <div className="ingredient-grid">

              {pantry.map((item) => (

                <div
                  key={item._id}
                  className="ingredient-chip"
                >
                  {item.ingredient}
                </div>

              ))}

            </div>
            <button
                className="btn btn-primary"
                onClick={() =>
                  //updateSuggestionCost({
                    //suggestionId: suggestion._id,
                    //username: suggestion.username,
                   // totalcost: pantryCost,
                  //})
                    console.log("calculate")
                }
                >
                Calculate Cost ${pantryCost.toFixed(2)}
                </button>

              <button
              className="btn btn-primary"
              onClick={() =>
                navigate(`/grocery/${userId}`)
              }
            >
              View Grocery List
            </button>

            <button
            className="btn btn-secondary"
            style={{ marginBottom: 20 }}
            onClick={() => navigate(`/pantry/${userId}`)}
          >
            Go to Pantry
          </button>

          
            <button
            className="btn btn-secondary"
            style={{ marginBottom: 20 }}
            onClick={() => navigate(`/wastedashboard/${userId}`)}
          >
            Go to Waste Dashboard
          </button>

          </div>
          

        );

      })}

    </div>
    </div>
  );
}